(() => {
  'use strict';

  const moneyFormat = window.FreshUpTheme?.moneyFormat || '${{amount}}';
  const rootUrl = window.Shopify?.routes?.root || '/';

  function formatMoney(cents, format = moneyFormat) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents || 0);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const withDelimiters = (number, precision = 2, thousands = '.', decimal = ',') => {
      if (Number.isNaN(number) || number == null) return '0';
      const parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    };
    const match = format.match(placeholder);
    if (!match) return withDelimiters(value) + ' €';
    let formatted;
    switch (match[1]) {
      case 'amount_no_decimals': formatted = withDelimiters(value, 0); break;
      case 'amount_with_comma_separator': formatted = withDelimiters(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': formatted = withDelimiters(value, 0, '.', ','); break;
      default: formatted = withDelimiters(value, 2, ',', '.');
    }
    return format.replace(placeholder, formatted);
  }

  function updateCartCount() {
    fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } })
      .then((res) => res.ok ? res.json() : Promise.reject(res))
      .then((cart) => document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      }))
      .catch(() => {});
  }

  document.querySelectorAll('[data-mobile-menu-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const drawer = document.querySelector('[data-mobile-drawer]');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('menu-open');
      drawer.querySelector('[data-mobile-menu-close]')?.focus();
    });
  });
  document.querySelectorAll('[data-mobile-menu-close], [data-mobile-drawer-scrim]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const drawer = document.querySelector('[data-mobile-drawer]');
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
      document.querySelector('[data-mobile-menu-open]')?.focus();
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelector('[data-mobile-menu-close]')?.click();
  });

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input[type="number"]');
    quantity.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        if (!input) return;
        const step = Number(input.step || 1);
        const min = Number(input.min || 1);
        const max = input.max ? Number(input.max) : Infinity;
        const next = Number(input.value || min) + (button.dataset.quantityAction === 'increase' ? step : -step);
        input.value = Math.min(max, Math.max(min, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const jsonNode = section.querySelector('[data-product-json]');
    const form = section.querySelector('[data-product-form]');
    if (!jsonNode || !form) return;
    let variants = [];
    try { variants = JSON.parse(jsonNode.textContent); } catch (_) { return; }

    const variantInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-cart]');
    const addText = addButton?.querySelector('[data-add-to-cart-text]');
    const message = form.querySelector('[data-product-message]');
    const priceNodes = section.querySelectorAll('[data-product-price]');
    const compareNodes = section.querySelectorAll('[data-compare-price]');
    const discountNodes = section.querySelectorAll('[data-discount-pill]');
    const selectedLabels = section.querySelectorAll('[data-selected-option]');

    function selectedOptions() {
      return Array.from(section.querySelectorAll('[data-product-option]')).map((fieldset) => {
        return fieldset.querySelector('input:checked')?.value || '';
      });
    }

    function selectMedia(mediaId) {
      if (!mediaId) return;
      section.querySelectorAll('[data-media-id]').forEach((media) => media.classList.toggle('is-active', String(media.dataset.mediaId) === String(mediaId)));
      section.querySelectorAll('[data-thumb-id]').forEach((thumb) => {
        const active = String(thumb.dataset.thumbId) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function setVariant(variant) {
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = window.FreshUpTheme?.labels?.unavailable || 'Nicht verfügbar';
        if (message) message.textContent = window.FreshUpTheme?.labels?.chooseVariant || 'Bitte wähle eine verfügbare Variante.';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      priceNodes.forEach((node) => node.textContent = formatMoney(variant.price));
      compareNodes.forEach((node) => {
        const show = variant.compare_at_price && variant.compare_at_price > variant.price;
        node.hidden = !show;
        node.textContent = show ? formatMoney(variant.compare_at_price) : '';
      });
      discountNodes.forEach((node) => {
        const show = variant.compare_at_price && variant.compare_at_price > variant.price;
        node.hidden = !show;
        node.textContent = show ? `Spare ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%` : '';
      });
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? (window.FreshUpTheme?.labels?.addToCart || 'In den Warenkorb') : (window.FreshUpTheme?.labels?.soldOut || 'Ausverkauft');
      if (message) message.textContent = '';
      if (variant.featured_media?.id) selectMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      section.dispatchEvent(new CustomEvent('freshup:variant-change', { detail: { variant } }));
    }

    section.querySelectorAll('[data-product-option] input').forEach((input) => {
      input.addEventListener('change', () => {
        const options = selectedOptions();
        selectedLabels.forEach((label, index) => { label.textContent = options[index] || ''; });
        const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
        setVariant(variant);
      });
    });

    section.querySelectorAll('[data-thumb-id]').forEach((thumb) => {
      thumb.addEventListener('click', () => selectMedia(thumb.dataset.thumbId));
    });

    section.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
      const activeImage = section.querySelector('.product-gallery__media.is-active img');
      if (activeImage?.requestFullscreen) activeImage.requestFullscreen();
    });

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || form.dataset.ajax === 'false') return;
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      addButton.setAttribute('aria-busy', 'true');
      addButton.disabled = true;
      if (message) message.textContent = window.FreshUpTheme?.labels?.adding || 'Wird hinzugefügt …';
      try {
        const response = await fetch(`${rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Fehler beim Hinzufügen.');
        if (message) message.textContent = window.FreshUpTheme?.labels?.added || 'Zum Warenkorb hinzugefügt.';
        updateCartCount();
      } catch (error) {
        if (message) message.textContent = error.message;
      } finally {
        addButton.removeAttribute('aria-busy');
        addButton.disabled = false;
      }
    });

    const sticky = section.querySelector('[data-sticky-atc]');
    if (sticky && addButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
      observer.observe(addButton);
      sticky.querySelector('[data-sticky-submit]')?.addEventListener('click', () => form.requestSubmit());
      section.addEventListener('freshup:variant-change', (event) => {
        sticky.querySelector('[data-sticky-price]').textContent = formatMoney(event.detail.variant.price);
      });
    }
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
})();
